import React from 'react';
import './style.scss';
import clsx from 'clsx';
import { SetState } from '../../../../utils/ISetState';

interface TextFieldProps {
  value: string;
  setValue: (string) => any | SetState<string>;
  className?: string;
  style?: any;
  align?: 'left' | 'center';
  autoFocus?: boolean;
  disabled?: boolean;
  type?: 'text' | 'price';
  fullWidth?: boolean;
  placeholder?: string;
  symbolsLimit?: number;
  valid?: boolean;
  onEnterPress?: () => any;
}

const notNumeric = new RegExp(/\D/);

const TextField = ({
  value,
  setValue,
  className = '',
  style = {},
  align = 'left',
  autoFocus = false,
  disabled = false,
  type = 'text',
  fullWidth = false,
  placeholder = undefined,
  symbolsLimit = -1,
  valid = true,
  onEnterPress
}: TextFieldProps) => {
  const onChange = (e) => {
    const newValue = e.target.value;
    if (symbolsLimit > 0 && newValue.length > symbolsLimit) {
      return;
    }
    if (type === 'price' && notNumeric.test(newValue)) {
      return;
    }
    setValue(newValue);
  };

  const onKeyDown = (e) => {
    if (onEnterPress && e.key === 'Enter') {
      onEnterPress();
    }
  };

  return (
    <input
      type='text'
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      style={style}
      className={clsx(
        'textfield',
        fullWidth && 'fullwidth',
        !valid && 'invalid',
        `textfield-${align}`,
        className
      )}
      autoFocus={autoFocus}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
};

export default TextField;
